import { I_QREditorFormTemplate } from "@/data/types/pages";
import { getRuleErrorMessage } from "@/utils/formHelper";
import { qrNameValidation } from "./shared";
import { TFunction } from "i18next";

export const qrSocialValidation = (data: I_QREditorFormTemplate, t: TFunction) => {
  return [
    qrNameValidation(t),
    {
      name: "headline",
      rules: {
        required: {
          value: true,
          message: getRuleErrorMessage("headline", "required", data),
        },
        maxLength: {
          value: 100,
          message: getRuleErrorMessage("headline", "maxLength", data),
        },
      },
    },
    {
      name: "description",
      rules: {
        maxLength: {
          value: 200,
          message: getRuleErrorMessage("description", "maxLength", data),
        },
      },
    },
  ];
};
